import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { LoaderCircleIcon } from "lucide-react";
import { useCallback, useEffect, useRef } from "react";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/start-campaign/",
)({
  validateSearch: zodValidator(
    z.object({
      skipCreditCheck: z.boolean().optional(),
    }),
  ),
  beforeLoad: async ({ search }) => {
    return {
      skipCreditCheck: search.skipCreditCheck ?? false,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const historyState = context.useHistoryState();
  const { startCampaignMutation } = context.useEditCampaign();

  const navigate = useNavigate();

  const startCampaign = useCallback(async () => {
    if (!startCampaignMutation.isIdle) {
      await navigate(historyState.returnTo);
      return;
    }

    await Promise.all([
      startCampaignMutation.mutateAsync({
        ignoreCredits: context.skipCreditCheck,
      }),
      new Promise((resolve) => setTimeout(resolve, 3000)),
    ]);
    await navigate(historyState.returnTo);
  }, [
    context.skipCreditCheck,
    historyState.returnTo,
    navigate,
    startCampaignMutation,
  ]);

  const isStartingRef = useRef(false);

  useEffect(() => {
    if (isStartingRef.current) return;
    isStartingRef.current = true;
    startCampaign();
  }, [startCampaign]);

  return (
    <div className="flex grow flex-col items-center justify-center gap-y-3">
      <LoaderCircleIcon
        className="text-theme-primary size-10 animate-spin"
        aria-hidden="true"
      />

      <div className="text-xs">Starter kampagnen - vent et øjeblik</div>
    </div>
  );
}
